

<div class="accordion-item" *ngIf="anterior" [class]="readonly ? 'info-card m-0 p-0' : ''">
    <h2 class="accordion-header m-0">
        <button [style]="readonly ? 'background-color: #FAF9F9; font-size: 14px;' : ''" class="accordion-button collapsed p-0 p-3" type="button" data-bs-toggle="collapse" [attr.data-bs-target]="'#pdf-' + readonly">
            Pontic design &nbsp;&nbsp; <span style="font-size: small; color: #707070;">(for front tooth {{dataService.rearrangedTeethOrder(teeth)}})</span>
        </button>
    </h2>

     <div id="pdf-{{readonly}}" [class]="!readonly ? 'accordion-collapse collapse' : 'accordion'" >
        <div class="accordion-body container text-center px-3 pt-2">
            <div class="radio-cards-container" style="max-width: 100%;">
       
                <label [style]="readonly ? 'width: 100%;' : 'width: 30%;'" class="radio-card-label mb-4" *ngIf="!readonly || orderDetailsNew.props['pontic-Pontic design-front'] == 'tangential'">
                    <input [disabled]="readonly" type="radio" name="pdf-{{readonly}}" [(ngModel)]="orderDetailsNew.props['pontic-Pontic design-front']" value="tangential" class="hidden-radio-input" />
                    <div class="custom-radio-indicator" data-html2canvas-ignore><div class="custom-radio-indicator-dot"></div></div>
                    <div class="card-icon">
                     <app-magnifier [contentTemplate]="apppropphtml501"></app-magnifier>
                        <ng-template #apppropphtml501>
                        <div class="magnify-content">
                            <div class="img-center">
                           <img width="100" height="auto" src="Asset_Image_Gity_V3/Anatomie_Pontic/for_front_tooth_11_12_13/Tangential_2.png" />
                           </div>
                             <div class="card-text" style="width: 5rem;">1. Tangential</div>
                        </div>
                        </ng-template>
                    </div>
                    <div class="radio-card-overlay"></div>
                </label>
                <label [style]="readonly ? 'width: 100%;' : 'width: 30%;'" class="radio-card-label mb-4" *ngIf="!readonly || orderDetailsNew.props['pontic-Pontic design-front'] == 'sattel-a'">
                    <input [disabled]="readonly" type="radio" name="pdf-{{readonly}}" [(ngModel)]="orderDetailsNew.props['pontic-Pontic design-front']" value="sattel-a" class="hidden-radio-input" />
                    <div class="custom-radio-indicator" data-html2canvas-ignore><div class="custom-radio-indicator-dot"></div></div>
                    <div class="card-icon">
                     <app-magnifier [contentTemplate]="apppropphtml502"></app-magnifier>
                        <ng-template #apppropphtml502>
                        <div class="magnify-content">
                            <div class="img-center">
                          <img width="100" height="auto" src="Asset_Image_Gity_V3/Anatomie_Pontic/for_front_tooth_11_12_13/Sattel_A_2.png" />
                          </div>
                            <div class="card-text" style="width: 5rem;">2. Sattel a)</div>
                        </div>
                        </ng-template>
                    </div>
                    <div class="radio-card-overlay"></div>
                </label>
                <label [style]="readonly ? 'width: 100%;' : 'width: 30%;'" class="radio-card-label mb-4" *ngIf="!readonly || orderDetailsNew.props['pontic-Pontic design-front'] == 'sattel-b'">
                    <input [disabled]="readonly" type="radio" name="pdf-{{readonly}}" [(ngModel)]="orderDetailsNew.props['pontic-Pontic design-front']" value="sattel-b" class="hidden-radio-input" />
                    <div class="custom-radio-indicator" data-html2canvas-ignore><div class="custom-radio-indicator-dot"></div></div>
                    <div class="card-icon">
                     <app-magnifier [contentTemplate]="apppropphtml503"></app-magnifier>
                        <ng-template #apppropphtml503>
                        <div class="magnify-content">
                        <div class="img-center">
                          <img width="100" height="auto" src="Asset_Image_Gity_V3/Anatomie_Pontic/for_front_tooth_11_12_13/Sattel_B_2.png" />
                          </div>
                            <div class="card-text" style="width: 5rem;">3. Sattel b)</div>
                        </div>
                        </ng-template>
                    </div>
                    <div class="radio-card-overlay"></div>
                </label>
                <label [style]="readonly ? 'width: 100%;' : 'width: 30%;'" class="radio-card-label mb-4" *ngIf="!readonly || orderDetailsNew.props['pontic-Pontic design-front'] == 'pontic-a'">
                    <input [disabled]="readonly" type="radio" name="pdf-{{readonly}}" [(ngModel)]="orderDetailsNew.props['pontic-Pontic design-front']" value="pontic-a" class="hidden-radio-input" />
                    <div class="custom-radio-indicator" data-html2canvas-ignore><div class="custom-radio-indicator-dot"></div></div>
                    <div class="card-icon">
                    <app-magnifier [contentTemplate]="apppropphtml504"></app-magnifier>
                        <ng-template #apppropphtml504>
                        <div class="magnify-content">
                            <div class="img-center">
                         <img width="100" height="auto"src="Asset_Image_Gity_V3/Anatomie_Pontic/for_front_tooth_11_12_13/Pontic_A_2.png" />
                         </div>
                          <div class="card-text" style="width: 5rem;">4. Pontic a)</div>
                        </div>
                        </ng-template>
                    </div>          
                    <div class="radio-card-overlay"></div>
                </label>
                <label [style]="readonly ? 'width: 100%;' : 'width: 30%;'" class="radio-card-label mb-4" *ngIf="!readonly || orderDetailsNew.props['pontic-Pontic design-front'] == 'pontic-b'">
                    <input [disabled]="readonly" type="radio" name="pdf-{{readonly}}" [(ngModel)]="orderDetailsNew.props['pontic-Pontic design-front']" value="pontic-b" class="hidden-radio-input" />
                    <div class="custom-radio-indicator" data-html2canvas-ignore><div class="custom-radio-indicator-dot"></div></div>
                    <div class="card-icon">
                     <app-magnifier [contentTemplate]="apppropphtml505"></app-magnifier>
                        <ng-template #apppropphtml505>
                        <div class="magnify-content">
                        <div class="img-center">
                        <img width="100" height="auto" src="Asset_Image_Gity_V3/Anatomie_Pontic/for_front_tooth_11_12_13/Pontic_B_2.png" />
                        </div>
                         <div class="card-text" style="width: 5rem;">5. Pontic b)</div>
                        </div>
                        </ng-template>
                    </div>
                    <div class="radio-card-overlay"></div>
                </label>

            </div>
           
            <div class="info-divider mt-4" *ngIf="readonly"></div>

            <div class="info-row" *ngIf="readonly">
                <div class="info-label">Contact Strength</div><div class="info-value">{{orderDetailsNew.props['pontic-Contact Strength-front']}}</div>
            </div>

            <div class="row mt-2" *ngIf="!readonly">
                <div class="col" style="color: #205567;">
                    <p class="ms-1 text-start">Contact Strength (mm)</p>
                    <div class="d-flex gap-2">
                        <input  type="number" [ngModel]="orderDetailsNew.props['pontic-Contact Strength-front']" class="customInputFields" style="width: 100px; height: 45px;" max="5" min="-0.60"/>  
                        <mat-slider [min]="-.60" [max]="5" [step]=".01" [discrete]="true" style="width: 100%;" [disabled]="readonly">
                        <input matSliderThumb [(ngModel)]="orderDetailsNew.props['pontic-Contact Strength-front']" #slider>
                        </mat-slider>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>




<div class="accordion-item" *ngIf="!anterior" [class]="readonly ? 'info-card m-0 p-0' : ''">
    <h2 class="accordion-header m-0">
        <button [style]="readonly ? 'background-color: #FAF9F9; font-size: 14px;' : ''" class="accordion-button collapsed p-0 p-3" type="button" data-bs-toggle="collapse" [attr.data-bs-target]="'#pds-' + readonly">
            Pontic design &nbsp;&nbsp; <span style="font-size: small; color: #707070;">(for side tooth {{dataService.rearrangedTeethOrder(teeth)}})</span>
        </button>
    </h2>


     <div id="pds-{{readonly}}" [class]="!readonly ? 'accordion-collapse collapse' : 'accordion'" >
        <div class="accordion-body container text-center px-3 pt-2">
            <div class="radio-cards-container" style="max-width: 100%;">
       
                <label [style]="readonly ? 'width: 100%;' : 'width: 30%;'" class="radio-card-label mb-4" *ngIf="!readonly || orderDetailsNew.props['pontic-Pontic design-side'] == 'Tangential'">
                    <input [disabled]="readonly" type="radio" name="pds-{{readonly}}" [(ngModel)]="orderDetailsNew.props['pontic-Pontic design-side']" value="Tangential" class="hidden-radio-input" />
                    <div class="custom-radio-indicator" data-html2canvas-ignore><div class="custom-radio-indicator-dot"></div></div>
                    <div class="card-icon">
                     <app-magnifier [contentTemplate]="apppropphtml505"></app-magnifier>
                        <ng-template #apppropphtml505>
                        <div class="magnify-content">
                        <div class="img-center">
                       <img width="100"  src="Asset_Image_Gity_V3/Anatomie_Pontic/for_side_tooth_14, 15, 16, 17, 18/TANGENTIAL_STANDARD_2.png" />
                       </div>
                        <div class="card-text" style="width: 5rem;text-align:left;text-align: left;line-height: 1.2;"> Tangential<br />(Standard)</div>
                        </div>
                        </ng-template>
                    </div>
                    <div class="radio-card-overlay"></div>
                </label>
                <label [style]="readonly ? 'width: 100%;' : 'width: 30%;'" class="radio-card-label mb-4" *ngIf="!readonly || orderDetailsNew.props['pontic-Pontic design-side'] == 'saddle shape'">
                    <input [disabled]="readonly" type="radio" name="pds-{{readonly}}" [(ngModel)]="orderDetailsNew.props['pontic-Pontic design-side']" value="saddle shape" class="hidden-radio-input" />
                    <div class="custom-radio-indicator" data-html2canvas-ignore><div class="custom-radio-indicator-dot"></div></div>
                    <div class="card-icon">
                     <app-magnifier [contentTemplate]="apppropphtml506"></app-magnifier>
                        <ng-template #apppropphtml506>
                        <div class="magnify-content">
                        <div class="img-center">
                        <img width="100" height="auto" src="Asset_Image_Gity_V3/Anatomie_Pontic/for_side_tooth_14, 15, 16, 17, 18/SHADDEL_SHAPE_2.png"/>
                        </div>
                        <div class="card-text" style="width: 7rem;">Saddle shape</div>
                        </div>
                        </ng-template>
                    </div>
                    <div class="radio-card-overlay"></div>
                </label>
                <label [style]="readonly ? 'width: 100%;' : 'width: 30%;'" class="radio-card-label mb-4" *ngIf="!readonly || orderDetailsNew.props['pontic-Pontic design-side'] == 'saddle shape 2'">
                    <input [disabled]="readonly" type="radio" name="pds-{{readonly}}" [(ngModel)]="orderDetailsNew.props['pontic-Pontic design-side']" value="saddle shape 2" class="hidden-radio-input" />
                    <div class="custom-radio-indicator" data-html2canvas-ignore><div class="custom-radio-indicator-dot"></div></div>
                    <div class="card-icon">
                    <app-magnifier [contentTemplate]="apppropphtml506"></app-magnifier>
                        <ng-template #apppropphtml506>
                        <div class="magnify-content">
                        <div class="img-center">
                        <img width="100" height="auto" src="Asset_Image_Gity_V3/Anatomie_Pontic/for_side_tooth_14, 15, 16, 17, 18/SHADDEL_SHAPE2_2.png" />
                        </div>
                        <div class="card-text" style="width: 8rem;">Saddle shape 2</div>
                        </div>
                        </ng-template>
                    </div>
                   
                    <div class="radio-card-overlay"></div>
                </label>
                <label [style]="readonly ? 'width: 100%;' : 'width: 30%;'" class="radio-card-label mb-4" *ngIf="!readonly || orderDetailsNew.props['pontic-Pontic design-side'] == 'floating element'">
                    <input [disabled]="readonly" type="radio" name="pds-{{readonly}}" [(ngModel)]="orderDetailsNew.props['pontic-Pontic design-side']" value="floating element" class="hidden-radio-input" />
                    <div class="custom-radio-indicator" data-html2canvas-ignore><div class="custom-radio-indicator-dot"></div></div>
                    <div class="card-icon">
                      <app-magnifier [contentTemplate]="apppropphtml507"></app-magnifier>
                        <ng-template #apppropphtml507>
                        <div class="magnify-content">
                        <div class="img-center">
                       <img width="100" height="auto" src="Asset_Image_Gity_V3/Anatomie_Pontic/for_side_tooth_14, 15, 16, 17, 18/FLOATING_ELEMENT_2.png"/>
                       </div>
                         <div class="card-text" style="width: 7rem;">Floating element</div>
                        </div>
                        </ng-template>
                    </div>
                    <div class="radio-card-overlay"></div>
                </label>
                <label [style]="readonly ? 'width: 100%;' : 'width: 30%;'" class="radio-card-label mb-4" *ngIf="!readonly || orderDetailsNew.props['pontic-Pontic design-side'] == 'root pontic'">
                    <input [disabled]="readonly" type="radio" name="pds-{{readonly}}" [(ngModel)]="orderDetailsNew.props['pontic-Pontic design-side']" value="root pontic" class="hidden-radio-input" />
                    <div class="custom-radio-indicator" data-html2canvas-ignore><div class="custom-radio-indicator-dot"></div></div>
                    <div class="card-icon">
                     <app-magnifier [contentTemplate]="apppropphtml508"></app-magnifier>
                        <ng-template #apppropphtml508>
                        <div class="magnify-content">
                            <div class="img-center">
                           <img width="100" height="auto" src="Asset_Image_Gity_V3/Anatomie_Pontic/for_side_tooth_14, 15, 16, 17, 18/ROOT_PONTIC_2.png" />
                           </div>
                           <div class="card-text" style="width: 5rem;">Root pontic</div>
                        </div>
                        </ng-template></div>
                    <div class="radio-card-overlay"></div>
                </label>

            </div>
           
            <div class="info-divider mt-4" *ngIf="readonly"></div>

            <div class="info-row" *ngIf="readonly">
                <div class="info-label">Contact Strength</div><div class="info-value">{{orderDetailsNew.props['pontic-Contact Strength-side']}}</div>
            </div>

            <div class="row mt-2" *ngIf="!readonly">
                <div class="col" style="color: #205567;">
                    <p class="ms-1 text-start">Contact Strength (mm)</p>
                    <div class="d-flex gap-2">
                        <input  type="number" [ngModel]="orderDetailsNew.props['pontic-Contact Strength-side']" class="customInputFields" style="width: 100px; height: 45px;" max="5" min="-.60"/>  
                        <mat-slider [min]="-.60" [max]="5" [step]=".01" [discrete]="true" style="width: 100%;" [disabled]="readonly">
                        <input matSliderThumb [(ngModel)]="orderDetailsNew.props['pontic-Contact Strength-side']" #slider>
                        </mat-slider>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</div>
